/**
 * Strips style tags and inline style attributes from HTML content coming out of
 * Shopware text editors, so editor styling cannot break the storefront layout.
 */
export function useRemoveStyle(html?: string | null): string {
    if (!html) return '';

    return html
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/\sstyle\s*=\s*"[^"]*"/gi, '')
        .replace(/\sstyle\s*=\s*'[^']*'/gi, '');
}
